module.exports = __webpack_public_path__ + "img/home-calendar.11803839.png";